import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Utils from '@/utils';
import AudioCompressCompleteRender from './children/AudioCompressCompleteRender';
import '@/assets/audioCompress.less';
import sentGAEvent from '@/ga';
class AudioCompressCompleteFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFileGuidList: [],
    };
  }

  componentDidMount() {
    let selectedFileGuidList = [];
    this.props.audioCompressAfterList
      .filter((item) => item.status === 'success')
      .forEach((item) => {
        selectedFileGuidList.push(item.guid);
      });
    this.setState({ selectedFileGuidList });
  }

  handleFileSelect = (selectedList) => {
    this.setState({
      selectedFileGuidList: selectedList,
    });
  };

  handleDownload = () => {
    sentGAEvent({
      category: 'DownloadStart',
      action: '28AC_DownloadStart',
      label: 'Null',
    });
    this.props.audioCompressAfterList
      .filter(
        (item) => this.state.selectedFileGuidList.indexOf(item.guid) !== -1
      )
      .forEach((item) => {
        Utils.downloadFile(item, item.format);
      });
  };

  render() {
    return (
      <AudioCompressCompleteRender
        submitStatus={this.props.submitStatus}
        selectedFileGuidList={this.state.selectedFileGuidList}
        audioCompressAfterList={this.props.audioCompressAfterList}
        handleFileSelect={this.handleFileSelect}
        handleDownload={this.handleDownload}
        handleSubmitAgain={this.props.handleSubmitAgain}
        deleteAudioCompressAfterItem={this.props.deleteAudioCompressAfterItem}
      />
    );
  }
}

export default withTranslation(['audioCompress'])(
  AudioCompressCompleteFunction
);
